import React from 'react';

const BergvarmepumpIcon = ({ size = 64 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <line x1="20" y1="36" x2="20" y2="4" stroke="#333" strokeWidth="4" />
        <line x1="44" y1="36" x2="44" y2="4" stroke="#333" strokeWidth="4" />
        <line x1="18" y1="4" x2="46" y2="4" stroke="#333" strokeWidth="4" />
        <line x1="32" y1="10" x2="32" y2="54" stroke="#333" strokeWidth="4" strokeLinecap="round" />
        <line x1="26" y1="18" x2="38" y2="18" stroke="#333" strokeWidth="4" strokeLinecap="round" />
        <line x1="26" y1="24" x2="38" y2="24" stroke="#333" strokeWidth="4" strokeLinecap="round" />
        <line x1="26" y1="30" x2="38" y2="30" stroke="#333" strokeWidth="4" strokeLinecap="round" />
        <line x1="6" y1="36" x2="26" y2="36" stroke="#333" strokeWidth="4" strokeLinecap="round" />
        <line x1="38" y1="36" x2="58" y2="36" stroke="#333" strokeWidth="4" strokeLinecap="round" />
        <line x1="22" y1="43" x2="42" y2="43" stroke="#333" strokeWidth="4" strokeLinecap="round" />
        <path d="M28 8L32 4L36 8" stroke="#333" strokeWidth="4" transform="scale(1, -1) translate(0, -58)" strokeLinecap="round" />
    </svg>
);

export default BergvarmepumpIcon;
